/* eslint-disable @typescript-eslint/no-explicit-any */
import {AxiosRequestConfig} from 'axios';
import config from '../../data/config';
import store from '../redux/store';
import apiClient from './api.config';

const TIMEOUT = 300000;

export const headers = () => {
  const users = (store.getState() as any).user;

  return {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'X-Frame-Options': 'deny',
    'X-Content-Type-Options': 'nosniff',
    'X-XSS-Protection': '1; mode=block',
    'Referrer-Policy': 'no-referrer',

    Pragma: 'no-cache',
    Expires: '0',
    Authorization: `Bearer ${users ? users.data.accessToken : ''}`,
  };
};

export const headerFormData = () => {
  const user = (store.getState() as any).user;
  const token = user && user.data && `Bearer ${user.data.accessToken}`;
  return {
    'Content-Type': 'multipart/form-data',
    Authorization: token,
    'X-Frame-Options': 'deny',
    'X-Content-Type-Options': 'nosniff',
    'X-XSS-Protection': '1; mode=block',
    'Referrer-Policy': 'no-referrer',
    accept: 'application/json',
    // 'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  };
};

export const get = async (url: string, params = {}) => {
  const user = (store.getState() as any).user;
  const tokenValide = user && user.data && `Bearer ${user.data.accessToken}`;

  try {
    const result = await apiClient({
      params: null,
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        Authorization: tokenValide,
        'X-Frame-Options': 'deny',
        'X-Content-Type-Options': 'nosniff',
        'X-XSS-Protection': '1; mode=block',
        'Referrer-Policy': 'no-referrer',
      },
      url: `${config.baseURL}${config.pathApi}${url}`,
      data: undefined,
      timeout: TIMEOUT,
      ...params,
    });
    const {data} = result;

    return data;
  } catch (error: any) {
    if (error?.response?.status === 401) {
      (store.getState() as any).user = [];
    }
    return error?.response?.data;
  }
};

export const post = async (url: string, data: any) => {
  try {
    const user = (store.getState() as any).user;
    const tokenAcces = user && user.data && `Bearer ${user.data.accessToken}`;
    const res = await apiClient({
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        Authorization: tokenAcces,
        'X-Frame-Options': 'deny',
        'X-Content-Type-Options': 'nosniff',
        'X-XSS-Protection': '1; mode=block',
        'Referrer-Policy': 'no-referrer', //'same-origin',
      },
      url: `${config.baseURL}${config.pathApi}${url}`,
      data,
      timeout: TIMEOUT,
    });

    return res.data;
  } catch (e: any) {
    if (e?.response?.status === 401) {
      (store.getState() as any).user = [];
    }
    const errors =
      e && e.response && e.response.data
        ? JSON.parse(JSON.stringify(e.response.data))
        : {isError: true, message: e.message};
    return errors;
  }
};

export const put = async (url: string, data: any = {}, asData = false) => {
  try {
    const user = (store.getState() as any).user;
    const tokenAcces = user && user.data && `Bearer ${user.data.accessToken}`;

    const res = await apiClient({
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',

        'X-Frame-Options': 'deny',
        'X-Content-Type-Options': 'nosniff',
        'X-XSS-Protection': '1; mode=block',
        'Referrer-Policy': 'no-referrer',

        Pragma: 'no-cache',
        Expires: '0',
        Authorization: tokenAcces,
      },
      url: `${config.baseURL}${config.pathApi}${url}`,
      data,
      timeout: TIMEOUT,
    });

    return asData ? res?.data : res;
  } catch (e: any) {
    if (e?.response?.status === 401) {
      (store.getState() as any).user = [];
    }
    const errors =
      e && e.response && e.response.data
        ? JSON.parse(JSON.stringify(e.response.data))
        : {isError: true, message: e.message};
    return errors;
  }
};

export const remove = async (url: string) => {
  try {
    const res = await apiClient.delete(
      `${config.baseURL}${config.pathApi}${url}`,
      {
        headers: headers(),
      },
    );
    console.log(res);

    return res;
  } catch (e: any) {
    console.log(e.response);

    if (e?.response?.status === 401) {
      (store.getState() as any).user = [];
    }

    const errors =
      e && e.response && e.response.data
        ? JSON.parse(JSON.stringify(e.response.data))
        : {isError: true, message: e.message};
    return errors;
  }
};

export const postFormData = async (
  url: string | null,
  data: any,
  defaultUrl = '',
  defaultHeader: any = undefined,
  credentials = false,
) => {
  try {
    const axiosParams = credentials
      ? {
          method: 'POST',
          headers: defaultHeader ?? headerFormData(),
          url:
            defaultUrl.length > 0
              ? defaultUrl
              : `${config.baseURL}${config.pathApi}${url}`,
          data,
          timeout: 800000,
          withCredentials: true,
        }
      : {
          method: 'POST',
          headers: defaultHeader ?? headerFormData(),
          url:
            defaultUrl.length > 0
              ? defaultUrl
              : `${config.baseURL}${config.pathApi}${url}`,
          data,
          timeout: 800000,
        };
    const res = await apiClient(axiosParams as AxiosRequestConfig);
    return res;
  } catch (e: any) {
    console.error(e);
    if (e?.response?.status === 401) {
      (store.getState() as any).user = [];
    }

    const errors =
      e && e.response && e.response.data
        ? JSON.parse(JSON.stringify(e.response.data))
        : {isError: true, message: e.message};
    return errors;
  }
};

export const putFormData = async (url: string, data: any) => {
  try {
    const user = (store.getState() as any).user;
    const tokenValide = user && user.data && `Bearer ${user.data.accessToken}`;

    const res = await apiClient({
      method: 'put',
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: tokenValide,
        'X-Frame-Options': 'deny',
        'X-Content-Type-Options': 'nosniff',
        'X-XSS-Protection': '1; mode=block',
        'Referrer-Policy': 'no-referrer',
      },
      url: `${config.baseURL}${config.pathApi}${url}`,
      data,
      timeout: 9000000,
    });
    return res;
  } catch (e: any) {
    if (e?.response?.status === 401) {
      (store.getState() as any).user = [];
    }
    const errors =
      e && e.response && e.response.data
        ? JSON.parse(JSON.stringify(e.response.data))
        : {isError: true, message: JSON.stringify(e.message)};
    return errors;
  }
};

export const patch = async (url: string) => {
  const user = (store.getState() as any).user;
  const tokenValide = user && user.data && `Bearer ${user.data.accessToken}`;

  try {
    const result = await apiClient({
      params: null,
      method: 'patch',
      responseType: 'arraybuffer',
      maxBodyLength: Infinity,
      headers: {
        Authorization: tokenValide,
        'X-Frame-Options': 'deny',
        'X-Content-Type-Options': 'nosniff',
        'X-XSS-Protection': '1; mode=block',
        'Referrer-Policy': 'no-referrer',
      },
      url: `${config.baseURL}${config.pathApi}${url}`,
      data: undefined,
      timeout: TIMEOUT,
    });
    const {data} = result;

    return data;
  } catch (error: any) {
    if (error?.response?.status === 401) {
      (store.getState() as any).user = [];
    }
    if (error?.response?.status === 401) {
      (store.getState() as any).user = [];
    }
    return error?.response?.data;
  }
};

export default {
  get,
  patch,
  post,
  put,
  remove,
};
